import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { ActiveUser, FileCheckpointInfo } from '../../../shared/models';
import { ActiveUsersModel, createInitialActiveUsersState } from './active-users.models';
import { ByteAuditLogModificationEvent } from '../../services/active-users.service';

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'active-users' })
export class ActiveUsersStore extends Store<ActiveUsersModel> {
  constructor() {
    super(createInitialActiveUsersState());
  }

  setUsers(users: ActiveUser[]): void {
    this.update({ users });
  }

  addUser(user: ActiveUser): void {
    this.update((state) => ({
      users: [...state.users.filter((u) => u.username !== user.username), user],
    }));
  }

  removeUser(userName: string): void {
    this.update((state) => ({
      users: state.users.filter((u) => u.username !== userName),
    }));
  }

  setCheckpoint(checkpoint: FileCheckpointInfo | null): void {
    this.update({ currentCheckpoint: checkpoint });
  }

  setFileOutdated(isOutdated: boolean): void {
    this.update({ isFileOutdated: isOutdated });
  }

  setLastModificationEvent(event: ByteAuditLogModificationEvent | null): void {
    this.update({ lastModificationEvent: event });
  }

  setEnabled(isEnabled: boolean): void {
    this.update({ isEnabled });
  }

  setCurrentFileDataId(fileDataId: number | null): void {
    this.update({ currentFileDataId: fileDataId });
  }

  resetState(): void {
    this.update(createInitialActiveUsersState());
  }
}
